/* fish-desktop-pdp.js — desktop PDP column fix (2026-09-04)
 *
 * The lander template renders the bundle (fish_bundle_pdp) and the info tabs
 * (product_info_tabs) as their own sections UNDER the main product section.
 * That is right on mobile (one column) and wrong on desktop, where the info
 * column beside the gallery ends up holding only the title and the buy box
 * drops below the fold. At >= 990px this moves those two sections into the
 * product info column; below it they go back to their original slots.
 *
 * Loaded deferred from theme.liquid BEFORE the sections' own deferred scripts,
 * so the move happens before <fish-bundle> upgrades and its listeners bind in
 * the final position.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 990px)');
  var KEYS = ['__fish_bundle_pdp', '__product_info_tabs'];

  function sections() {
    return KEYS.map(function (k) {
      return document.querySelector('.shopify-section[id$="' + k + '"]');
    }).filter(Boolean);
  }

  function apply() {
    var info = document.querySelector('.product__info-wrapper .product__info-container');
    if (!info) return;
    var secs = sections();
    if (!secs.length) return;
    var slot = info.querySelector('.fish-desk-slot');
    if (MQ.matches) {
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'fish-desk-slot';
        info.appendChild(slot);
      }
      secs.forEach(function (s) {
        if (s.parentNode === slot) return;
        if (!s.__fishHome) {
          var ph = document.createElement('div');
          ph.className = 'fish-desk-placeholder';
          ph.hidden = true;
          s.parentNode.insertBefore(ph, s);
          s.__fishHome = ph;
        }
        slot.appendChild(s);
      });
      document.documentElement.classList.add('fish-desk-pdp');
    } else {
      secs.forEach(function (s) {
        if (s.__fishHome && s.parentNode !== s.__fishHome.parentNode) {
          s.__fishHome.parentNode.insertBefore(s, s.__fishHome);
        }
      });
      document.documentElement.classList.remove('fish-desk-pdp');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', apply);
  else MQ.addListener(apply);
})();
